




















































































import Vue from 'vue';
import moment from 'moment-timezone';

import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { PressaoArterialForm } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ThePressoesArteriaisDadosDialog',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    value: {
      type: Boolean,
    },
    pacienteNome: {
      type: String,
    },
    flagPa: {
      type: Boolean,
    },
    pressaoArterial: {
      type: Object as () => PressaoArterial | PressaoArterialForm,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
  },
  watch: {
    value() {
      this.dialog = this.value;
    },
  },
});
